<template>
  <div
    class="search-select"
    :class="{
      visible: isOpen,
      'search-select--disabled': disabled
    }"
    v-click-outside="() => (isOpen = false)"
    tabindex="0"
  >
    <div class="search-select__choose">
      <input
        :value="value"
        @input="$emit('input', $event.target.value)"
        type="text"
        @focus="isOpen = true"
        @keydown.esc="$emit('escape')"
        :placeholder="$t('common.search')"
        :disabled="disabled"
      />
      <div
        class="search-select__icon"
        @click="isOpen = disabled ? false : !isOpen"
      >
        <i class="search-select__arrow" />
      </div>
    </div>

    <div
      class="search-select__toggle"
      :class="{
        visible: isOpen
      }"
    >
      <div class="search-select__list-item">
        <ul class="search-select__list">
          <li
            class="search-select__item"
            v-for="option of filteredOptions"
            :key="option.name"
            @click="
              $emit('input', option.name);
              isOpen = false;
            "
          >
            {{ option.name }}
          </li>
          <li class="search-select__item" v-if="filteredOptions.length === 0">
            <span class="search-select__noitem">no elements</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
      default: ""
    },
    options: {
      type: Array,
      required: false,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    filteredOptions() {
      return this.options.filter(value =>
        value.name.toLowerCase().includes(this.value.toLowerCase())
      );
    }
  },
  data: () => ({
    isOpen: false
  })
};
</script>

<style lang="scss" scoped>
@import "../styles/variables";

.search-select {
  display: inline-block;
  position: relative;
  outline: none;
  background: $color-white;
  width: 100%;
  height: 40px;
  &.selected {
    &__choose {
      padding-right: 32px;
    }
  }
  &.visible {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
    .search-select__arrow {
      transform: rotate(45deg);
      margin-top: 0;
    }
  }
  &__choose {
    position: relative;
    display: inline-block;
    padding: 0 0;
    height: 40px;
    width: 100%;
    line-height: 40px;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333333 !important;
    > input {
      width: 100%;
      height: 40px;
      background: #fbfbfb;
      padding: 10px 15px;
      border: 1px solid #ececec;
      border-radius: 5px;
      outline: none !important;
      cursor: pointer;

      .search-select--disabled & {
        cursor: default;
        color: $color-medium-grey;
      }
    }
    &.visible {
      display: inline-block;
    }
  }
  &__arrow {
    position: absolute;
    content: "";
    border-left: 2px solid $color-black;
    border-top: 2px solid $color-black;
    width: 8px;
    height: 8px;
    transform: rotate(-133deg);
    right: 15px;
    top: 50%;
    margin-top: -5px;
    transition: all 0.3s;
    cursor: pointer;

    .search-select--disabled & {
      cursor: default;
      border-left: 2px solid $color-medium-grey;
      border-top: 2px solid $color-medium-grey;
    }
  }
  &__icon {
    width: 33px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    cursor: pointer;
    pointer-events: none;
  }
  &__toggle {
    position: absolute;
    z-index: 1;
    top: 39px;
    left: 0;
    right: 0;
    padding: 2px 0;
    margin: 0;
    opacity: 0;
    transform: translateY(-5px);
    transition: all 0.2s;
    background: #fdfdfd;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    pointer-events: none;
    ::-webkit-scrollbar {
      width: 7px;
    }
    ::-webkit-scrollbar-track {
      background: transparent;
    }
    ::-webkit-scrollbar-thumb {
      background: #d8d8d8;
      border-radius: 10px;
      transition: all 0.2s;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
    &.visible {
      opacity: 1;
      transform: translateY(0);
      transition: all 0.2s;
      pointer-events: visible;
    }
    &.open-up {
      bottom: 46px;
      top: initial;
    }
  }
  &__list-item {
    padding: 15px 0;
  }
  &__list {
    margin: 0 8px 0 0;
    padding: 0 0 0 0;

    list-style: none;
    overflow: auto;
    max-height: 200px;
  }
  &__item {
    list-style: none;
    padding: 13px 33px 13px 15px;
    color: #464646;
    transition: all 0.5s;
    position: relative;
    cursor: pointer;
    font-size: 13px;
    &:hover {
      background-color: #004593;
      color: $color-white;
    }
  }
  &__noitem {
    font-size: 12px;
    margin: 14px;
  }
}
</style>
